import { Box, styled } from "@mui/material";

export const FOCUSED_ROW_CLASS = "focused-parcel-row";

export const Container = styled(Box)({
  [`& .${FOCUSED_ROW_CLASS}.ag-row`]: {
    backgroundColor: "#FFF2A8",
  },
  // The selected-row background is an ::before overlay painted from this variable, so override
  // the variable too. This is required so that a checked _and_ focused row is coloured correctly.
  [`& .${FOCUSED_ROW_CLASS}.ag-row-selected`]: {
    "--ag-selected-row-background-color": "#FFF2A8",
  },
});
